import genericInfoHandlerComponent from 'app/components/highOrderComponents/genericInfoHandlerComponent/component'
import ResponseStatusWrapperComponent from 'app/components/highOrderComponents/noteButtonsWrapper/component'
// Can remove following comment when one more HOC is created

export const ResponseStatusWrapper = ResponseStatusWrapperComponent
export const genericInfoHandler = genericInfoHandlerComponent
